export default __webpack_public_path__ + "static/media/a18.0c190ee0.jpg";